window.addEventListener('DOMContentLoaded', () => {

    // --- === --- === [ FADE IN SLIDERS ] --- === --- === //
    document.querySelectorAll('.fade-in-slider').forEach(carousel => new Splide(carousel, {
        type: 'fade',
        arrows: true,
    }).mount());

    // --- === --- === [ BREW GUIDE SLIDERS ] --- === --- === //

    document.querySelectorAll('.brew-guide-slider').forEach(carousel => new Splide(carousel, {
        type: 'loop',
        perPage: 2,
        breakpoints: {
          1024: {
            perPage: 1,
          },
        },
        gap: '40px',
        focus: 'center',
        autoplay: false,
        interval: 8000,
        flickMaxPages: 3,
        updateOnMove: true,
        pagination: true,
        padding: '10%',
        throttle: 300,
        breakpoints: {
          1440: {
            perPage: 1,
            padding: '30%'
          }
        }
    }).mount());
})
